module.exports = __webpack_public_path__ + "static/media/homeBackground.6f5a111e.jpg";